import { uploadService } from './../../../../shared/uploadService';
import { Component, OnInit } from '@angular/core';
import { CooperationService } from '../../services/cooperation-services';
import { Cooperation } from '../../models/cooperation';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { FileVm } from '../../../../shared/Models/fileVm';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-cooperation',
  templateUrl: './add-cooperation.component.html',
  styleUrls: ['./add-cooperation.component.scss']
})
export class AddCooperationComponent implements OnInit {

  model = {} as Cooperation;
  attachements= new FormData();
  isEdit = false;
  constructor(
    private route : Router,
    private diagRef: NbDialogRef<AddCooperationComponent>,
    private service: CooperationService,
    private uploadService: uploadService,
    private toast: NbToastrService
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    if (this.isEdit) {
      this.uploadService.updateFiles({ files:[],previousAttachments: this.model.attachements});
    }
    if(!this.isEdit){
      this.model.contentAR = '';
      this.model.contentEN = '';
      this.uploadService.updateFiles({ files:[],previousAttachments: []});
    }

  }

  save() {
    // let fileInput = document.getElementById('attachements') as any;

  //   let hasEntries = false;
  // this.attachements.forEach(() => {
  //   hasEntries = true;
  // });

  //   if (hasEntries) {
  //     this.service.uploadMultipleFiles(this.attachements).subscribe((res) => {
  //       this.model.attachements = [];
  //       res.forEach((element) => {
  //         this.model.attachements.push({
  //           fileName: element,
  //         } as FileVm);
  //       });

  //       this.saveCooperation();
  //     });
  //   } else {
  //     this.saveCooperation();
  //   }

  this.uploadService.uploadMultipleFiles().pipe(
    switchMap((res) => {
      this.model.attachements = res;
      return this.isEdit ? this.service.put(this.model.id, this.model) : this.service.post(this.model);
    })
  ).subscribe({
    next: (res) => {
      this.diagRef.close('true');
      this.isEdit ? this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 }) : this.toast.show('تم الإضافة بنجاح', '', { status: 'success', duration: 3000 });
    },
    error: (err) => {
      this.diagRef.close('true');
      this.isEdit ? this.toast.danger('خطأ في التعديل', '', { status: 'success', duration: 3000 }) : this.toast.danger('خطأ في الحفظ', '', { status: 'success', duration: 3000 });
    }
  })
  }

  // saveCooperation() {
  //   this.service.post(this.model).subscribe((res) => {
  //     this.diagRef.close('true');
  //     this.toast.show('تم الإضافة بنجاح', '', { status: 'success', duration: 3000 });
  //   });
  // }

  // update(){
  //   this.service.put(this.model.id, this.model).subscribe((res) => {
  //     this.diagRef.close('true');
  //     this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 });
  //   });
  // }
  close() {
    this.diagRef.close();
  }

  isFormValid() {
    return this.model.nameAR;
  }

  // uploadFile(files: any) {
  //   for (let file of files) {
  //     this.attachements.append(file.name, file);
  //   }
  // }

}
